import { Typography } from '@mui/material';
import { PieChart } from '@mui/x-charts';

const Pie = ({ values = {} }) => {
  const size = 250;
  const STATUS_MAP = {
    PENDENTE: { label: 'PENDENTE', color: '#FFA726' },
    ATIVO: { label: 'ATIVO', color: '#2E7D32' },
    ATIVA: { label: 'ATIVA', color: '#2E7D32' },
    INATIVO: { label: 'INATIVO', color: '#C62828' },
    INATIVA: { label: 'INATIVA', color: '#C62828' },
  };

  const formatPieData = () => {
    return Object?.entries(values)?.map(([id, value]) => {
      const statusInfo = STATUS_MAP[id] || {
        label: 'Desconhecido',
        color: '#9E9E9E',
      };
      return {
        id: isNaN(+id) ? id : +id,
        value,
        label: statusInfo.label,
        color: statusInfo.color,
      };
    });
  };

  const data = formatPieData();

  if (data?.every((e) => e?.value === 0)) {
    return (
      <Typography variant="subtitle2" textAlign="center" fontWeight="normal">
        Nenhum registro encontrado
      </Typography>
    );
  }

  return (
    <PieChart
      height={size}
      margin={{ right: size }}
      series={[{ data: formatPieData(), innerRadius: 30 }]}
      slotProps={{
        legend: {
          position: { horizontal: 'right', vertical: 'middle' },
          labelStyle: { fontSize: 12 },
        },
      }}
    />
  );
};
export default Pie;
